import { createContext } from "react";
import { KeysysToastProps } from "../../component-library";
import { Any } from "../../test-helpers/Any";

export interface IToastContext {
    activeToasts: KeysysToastProps[];
    showToast: (toastProps: KeysysToastProps) => void;
    hideToast: (name: string) => void;
    errorToast: (error: unknown) => void;
}

const defaultValue: IToastContext = {
    activeToasts: [],
    showToast: Any.voidFn,
    hideToast: Any.voidFn,
    errorToast: Any.voidFn,
};

export const ToastContext = createContext<IToastContext>(defaultValue);
ToastContext.displayName = "Toast";
